import { Controller } from 'stimulus';

class FilterableElements {
  #tokenizedList;

  constructor() {
    this.#tokenizedList = new WeakMap();
  }

  add(element, value) {
    const token = value.toLowerCase();
    this.#tokenizedList.set(element, token);
  }

  filter(elements, query, callback) {
    query = query.toLowerCase();
    let totalMatch = 0;
    for (const element of elements) {
      const token = this.#tokenizedList.get(element);
      const result = token.includes(query);
      if (result) {
        totalMatch += 1;
      }
      callback(element, result);
    }
    return totalMatch;
  }
}

export default class extends Controller {
  static targets = ['option', 'noResults'];

  trackTextSearch() {
    window.ed.featureActionsService.add('text_library_searched');
  }

  initialize() {
    this.filterable = new FilterableElements();
  }

  toggleNoResults(condition) {
    this.noResultsTarget.classList.toggle('hidden', condition);
  }

  filter({ target }) {
    const value = target.value.trim();

    if (value === '') {
      this.toggleNoResults(true);
      for (const el of this.optionTargets) {
        el.classList.remove('hidden');
      }
      return;
    }

    const matchResults = this.filterable.filter(this.optionTargets, value, (option, match) => {
      option.classList.toggle('hidden', !match);
    });

    this.toggleNoResults(matchResults !== 0);
  }

  optionTargetConnected(option) {
    this.filterable.add(option, option.getAttribute(`data-${this.identifier}-value`));
  }
}
